module.exports = __webpack_public_path__ + "static/site-mobile-f9464796d76cf673c9a75e5ba69cc735.jpg";